import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { USER_TYPES } from 'src/constants';
import httpheader from 'src/Member/shared/httpheader';

export function withAuth(Component) {
  //debugger;
  return function HostComponent() {
    const [isEvaluated, setIsEvaluated] = useState(false);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState(null);
    const { isLoggedIn, userData } = useSelector(({ user }) => user);
    const isUserLoggedIn = userData && isLoggedIn;
    const navigate = useNavigate();

    useEffect(() => {
      if (httpheader.getCNAME() != 'a1m-qa') {
        navigate('/member/');
      }
      if (userData) {
        const redirectToUrl =
          USER_TYPES.EMPLOYEE === userData.UserType ||
          USER_TYPES.DEPENDENT === userData.UserType
            ? '/member/dashboard'
            : '/admin/admin-dashboard';
        setRedirectUrl(redirectToUrl);
        setShouldRedirect(isUserLoggedIn ? true : false);
      } else {
        setShouldRedirect(false);
      }
      setIsEvaluated(true);
    }, []);
    console.log(Component);
    return isEvaluated ? (
      shouldRedirect && redirectUrl ? (
        <Navigate to={redirectUrl} />
      ) : (
        <Component />
      )
    ) : null;
  };
}
